import { useItemsStock } from "@coworker/apprestructured/src/shared/hooks/item/useItemsStock";
import { useMemo } from "react";
import { Article } from "../types/article";

const getUniqueItems = (articles: Article[]): string[] => {
  const uniqItemNos = articles.reduce(
    (acc, { productArticleId, productArticleType }) =>
      acc.add(`${productArticleId}:${productArticleType}`),
    new Set<string>()
  );
  return Array.from(uniqItemNos);
};

export const useItemsStockInfo = (articles: Article[] = []) => {
  const items = useMemo(() => getUniqueItems(articles), [articles]);
  return useItemsStock(items);
};
